The date & time the candidate profile was last updated.
